module.exports = __webpack_public_path__ + "img/shengji.1f243a53.png";